import { createApp } from 'vue'
import StoryReader from '../components/StoryReader.vue'

export function mountStory() {
  const el = document.getElementById('story-app')
  if (!el) return

  const app = createApp(StoryReader, {
    level: parseInt(el.dataset.level),
    storyUrl: el.dataset.storyUrl,
    backUrl: el.dataset.backUrl,
    // Scripted conversations reuse this reader with dialogue content and its
    // own headings; the story page leaves these unset.
    kind: el.dataset.kind,
    heading: el.dataset.heading,
    subheading: el.dataset.subheading,
  })
  app.mount(el)
}
